<template>
    <section class="h_admin">
        <div class="hhead_row">
            <div class="hhead_col">
                <div class="hhead_push">
                    <i class="mdi mdi-bell-outline"><!--<span>5</span>--></i>
                </div>
                <div class="hhead_user">
                    <p>{{getUser.fullName}}
                        <a href="javascript:void(0)" @click="logout">Cerrar Sesión</a>
                    </p>
                    <img :src="getUser.profilePic" alt="" class="hhead_profile">
                </div>
            </div>
        </div>
    </section>
</template>

<script>

    import {mapGetters} from 'vuex'
    import {AUTH_LOGOUT} from '../../store/actions/auth'

    export default {
        components: {},
        data() {
            return {
                showCart: false,
                categories: [],
                subcategories: []
            }
        },
        computed: {
            ...mapGetters([
                'getUser'
            ]),
        },
        methods: {
            logout() {
                const self = this;
                self.$store.dispatch(AUTH_LOGOUT).then(() => self.$router.push({name: 'login'}))
            },
        },
        mounted: function () {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/Header.vue